import { Tabs } from "radix-ui";
import TabTrigger from "../../atoms/tabs/TabTrigger";
import TabContent from "../../atoms/tabs/TabContent";
import TabsList from "../../atoms/tabs/TabsList";

const TabsRoot = ({
  tabs,
  defaultValue,
  isSub = false,
  onValueChange = () => {},
}) => {
  return (
    <Tabs.Root
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      className="w-full"
    >
      <TabsList isSub={isSub}>
        {tabs.map((tab) => (
          <TabTrigger key={tab.value} value={tab.value} isSub={isSub}>
            {tab.label}
          </TabTrigger>
        ))}
      </TabsList>

      {tabs.map((tab) => (
        <TabContent key={tab.value} value={tab.value}>
          {tab.content}
        </TabContent>
      ))}
    </Tabs.Root>
  );
};

export default TabsRoot;
